import type { Quotation } from '@/services/quotation.service';

type UserLike = {
  first_name?: string | null;
  last_name?: string | null;
  username?: string | null;
  email?: string | null;
};

function formatUserLike(u: UserLike): string {
  const name = [u.first_name, u.last_name].filter(Boolean).join(' ').trim();
  return name || u.username || u.email || '';
}

export type QuotationOwnerSource = Pick<Quotation, 'sales_person' | 'prepared_by'> & {
  salesPersonUser?: UserLike | null;
  preparedByUser?: UserLike | null;
};

/** Resolve quotation owner for list/detail — prefers embedded user relations, else id lookup. */
export function resolveQuotationOwnerLabel(
  quotation: QuotationOwnerSource,
  resolveUserId?: (id: string | null | undefined, emptyLabel?: string) => string
): string {
  if (quotation.salesPersonUser) {
    const label = formatUserLike(quotation.salesPersonUser);
    if (label) return label;
  }
  if (quotation.preparedByUser && !quotation.sales_person) {
    const label = formatUserLike(quotation.preparedByUser);
    if (label) return label;
  }
  const id = quotation.sales_person || quotation.prepared_by;
  if (resolveUserId) {
    return resolveUserId(id);
  }
  return id || '—';
}
